import {Outlet} from "react-router-dom";
import {useAuthProfile} from "@/providers/AuthProfileProvider.tsx";
import {useEffect, useState} from "react";
import {getAuthProfile} from "@/api/apiMethods.ts";
import {AxiosError} from "axios";
import {FullScreenLoader} from "@/components/loader/FullScreenLoader.tsx";
import {Wish} from "@/api/types.ts";
import {ErrorState} from "@/components/ErrorState.tsx";
import {useTranslation} from "react-i18next";

export const AuthProfileLayout = () => {
    const { t } = useTranslation();
    const { authProfile, setAuthProfile } = useAuthProfile();
    const [ statusCode, setStatusCode ] = useState<number | null>(null);

    const refreshProfile = async () => {
        const fetchAuthProfile = async () => {
            return await getAuthProfile();
        };
        fetchAuthProfile().then((authProfile)=>{
            setStatusCode(200);
            setAuthProfile(authProfile);
        }).catch((error) => {
            if (error instanceof AxiosError) {
                setStatusCode(error.response?.status || 500);
            } else {
                setStatusCode(500);
            }
        });
    }

    useEffect(() => {
        refreshProfile().then(()=>{})
    }, [setAuthProfile]);

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const onWishSaved = async (_wish: Wish) => {
        await refreshProfile()
    }

    if (!statusCode) {
        return <FullScreenLoader/>;
    }

    if (statusCode === 503) {
        return <ErrorState title={""} description={t("state.temporaryUnavailable")}/>;
    }

    if (statusCode >= 500) {
        throw Error(`Profile HTTP 5xx state (${statusCode})`);
    }

    if (statusCode === 404) {
        throw Error("Profile not found state");
    }

    if (!authProfile) {
        throw Error(`Profile unknown state (${statusCode})`);
    }

    return (
        <Outlet context={{authProfile, onWishSaved, refreshProfile}}/>
    );
}
